// Compact case selector: priority, lifecycle state and type are independent.
import { Wrench, UserRound, MapPin, CircleAlert, Bell, HeartPulse, Wind } from "lucide-react";
import { lecturaEkhEvento } from "@/lib/consolaV3/ekhEvento";
import { CAPACIDAD_LABEL, ESTADO_LABEL } from "@/lib/alarmMeta";
import { verboEvento, verboEventoInst, esTecnica, elapsedHuman, nombreCorto, origenDispositivo } from "@/lib/consolaV3/meta";
import { visualPriority, locationFirst, eventSentence } from "@/components/visualV2/presentation";

export default function AlarmCardV3({ alarma: a, selected, onSelect, nowMs, stale }) {
  const tec = esTecnica(a);
  const ac = visualPriority(a.prioridad);
  const titulo = tec && a.tipo === "cobertura_perdida" && a.capacidad
    ? `${verboEvento(a.tipo)} · ${(CAPACIDAD_LABEL[a.capacidad] || a.capacidad).toUpperCase()}`
    : (a.modalidad_respuesta || a._modalidad) === "institucional" ? verboEventoInst(a.tipo) : verboEvento(a.tipo);
  const estado = a.estado === "recibida" ? "Sin tomar" : a.estado === "tomada" ? "En atención"
    : a.estado === "en_verificacion" ? "En verificación" : (ESTADO_LABEL[a.estado] || a.estado);
  const cui = a.cuidadora_en_turno;
  const origen = origenDispositivo(a);
  // GC106 — la lectura que originó la alerta se ve EN LA TARJETA, no sólo al final del expediente.
  const ekh = lecturaEkhEvento(a);
  return (
    <button data-testid={`v3-card-${a.id}`} data-priority={ac.key} data-type={tec ? "tecnico" : "persona"}
      aria-pressed={selected} onClick={() => onSelect(a.id)}
      className="gv2-card w-full text-left px-3 py-3 transition-colors">
      <div className="gv2-card-head">
        <span className="gv2-card-labels">
          <span className="gv2-priority-badge">{ac.key === "alta" ? <CircleAlert aria-hidden="true" /> : <Bell aria-hidden="true" />}{ac.label}</span>
          <span className="gv2-state">{estado}</span>
        </span>
        <span className="gv2-time-block"><span className="gv2-time-label">Hace</span><span data-testid={`v3-elapsed-${a.id}`} className="gv2-timer">{elapsedHuman(a.hora_recepcion_servidor, nowMs)}</span></span>
      </div>
      <p className="gv2-title">{eventSentence(titulo)}</p>
      {ekh && (
        <p data-testid={`v3-ekh-card-${a.id}`}
          className={`mt-2 inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-sm font-bold ${ekh.presente
            ? "bg-[#012472]/[0.07] text-[#012472] dark:bg-[#01CBE3]/[0.12] dark:text-[#80B3FF]"
            : "bg-slate-100 text-slate-500 dark:bg-slate-700/40 dark:text-slate-300"}`}>
          {ekh.esResp ? <Wind className="h-3.5 w-3.5" aria-hidden="true" /> : <HeartPulse className="h-3.5 w-3.5" aria-hidden="true" />}
          {ekh.texto}
        </p>
      )}
      {a.persona_nombre && <p className="gv2-person gv2-info-line mt-2"><UserRound aria-hidden="true" /><span>{a.persona_nombre}</span></p>}
      <p className="gv2-meta gv2-info-line gv2-location mt-1" title={locationFirst(a.zona_nombre, a.sitio_nombre)}>
        <MapPin aria-hidden="true" /><span>{locationFirst(a.zona_nombre, a.sitio_nombre) || "Ubicación no especificada"}</span>
      </p>
      <div className="gv2-card-foot">
        <span className="gv2-type">{tec ? <Wrench className="h-3.5 w-3.5" /> : <UserRound className="h-3.5 w-3.5" />}{tec ? "Incidencia técnica" : "Persona"}</span>
        {!tec && cui && <span data-testid={`v3-cuidadora-${a.id}`} className="gv2-meta min-w-0">
          {(a.modalidad_respuesta || a._modalidad) === "institucional" ? "Responsable de turno" : "Cuidadora en turno"}: {nombreCorto(cui.nombre)}
        </span>}
      </div>
      {!tec && origen && <p data-testid={`v3-origen-${a.id}`} className="gv2-meta mt-1 truncate">Origen: {origen.texto}</p>}
      {stale && <span className="gv2-state mt-2">Dato desactualizado</span>}
    </button>
  );
}
